import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp } from "./Reveal";
import { useI18n } from "@/context/Language";

const Chapter = ({ chapter, index, image }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [40, -40]);
  const flip = index % 2 === 1;

  return (
    <div ref={ref} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
      <div className={`lg:col-span-5 ${flip ? "lg:order-2 lg:col-start-8" : ""}`}>
        <FadeUp>
          <div className="flex items-center gap-4">
            <span className="font-serif text-6xl text-terracotta/25 leading-none">{chapter.n}</span>
            <span className="text-xs uppercase tracking-[0.2em] text-ink/50">{chapter.tag}</span>
          </div>
          <h3 className="mt-5 font-serif text-3xl sm:text-4xl tracking-tight text-ink">{chapter.title}</h3>
          <p className="mt-5 text-base sm:text-lg leading-relaxed text-ink/70">{chapter.body}</p>
        </FadeUp>
      </div>

      <div className={`lg:col-span-6 ${flip ? "lg:order-1 lg:col-start-1" : "lg:col-start-7"}`}>
        <div className="relative aspect-[4/3] w-full overflow-hidden border border-border-soft">
          <motion.img src={image} alt={chapter.title} style={{ y }} className="absolute inset-0 h-[118%] w-full object-cover" />
        </div>
      </div>
    </div>
  );
};

export const Manifesto = () => {
  const { t, N } = useI18n();
  const M = t.manifesto;
  const images = [N.images.disasterSite, N.images.mealsCarry, N.images.groceryCart];

  return (
    <section id="story" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <FadeUp>
          <div className="max-w-2xl">
            <span className="text-xs uppercase tracking-[0.24em] text-terracotta">{M.overline}</span>
            <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight leading-[1.02] text-ink text-balance">
              {M.heading}
            </h2>
          </div>
        </FadeUp>

        <div className="mt-16 sm:mt-24 space-y-24 sm:space-y-32">
          {M.chapters.map((c, i) => (
            <Chapter key={c.n} chapter={c} index={i} image={images[i]} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
